import React from 'react';
import { Form, Button, Alert, Spinner, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, ArrowRight } from 'lucide-react';
import { triggerMediumHaptic } from '../../utils/haptics';

const PasswordLoginForm = ({
  identifier,
  setIdentifier,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  handlePasswordLogin,
  message,
  loading
}) => {
  return (
    <>
      {message.text && message.type === 'danger' && (
        <Alert variant="danger" className="py-2 small">{message.text}</Alert>
      )}
      <Form onSubmit={handlePasswordLogin}>
        <Form.Group className="mb-4">
          <Form.Label className="form-label-custom d-none">Email or Mobile</Form.Label>
          <InputGroup className="login-input-group">
            <InputGroup.Text><Mail size={18}/></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Enter your email or mobile number"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              className="form-ctrl-login-custom"
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label className="form-label-custom d-none">Password</Form.Label>
          <InputGroup className="login-input-group">
            <InputGroup.Text><Lock size={18}/></InputGroup.Text>
            <Form.Control
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-ctrl-login-custom"
            />
            <InputGroup.Text 
              className="cursor-pointer" 
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={18}/> : <Eye size={18}/>}
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>

        <div className="remember-forgot-wrapper d-flex justify-content-between align-items-center mb-4">
          <Form.Check
            type="checkbox"
            label={<span className="text-secondary small">Remember me</span>}
            className="custom-checkbox"
          />
          <Link to="/forgot-password" size="sm" className="forgot-link small">
            Forgot password?
          </Link>
        </div>

        <div className="sticky-mobile-cta">
          <Button 
            type="submit" 
            className="btn-auth-primary w-100 native-btn" 
            disabled={loading} 
            onClick={() => triggerMediumHaptic()}
          >
            {loading ? (
              <>
                <Spinner size="sm" animation="border" />
                <span>SIGNING IN...</span>
              </>
            ) : (
              <>
                <span>SIGN IN</span>
                <ArrowRight size={18} />
              </>
            )}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default PasswordLoginForm;
